import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  educationLevelsLength: 0,
  educationLevels: [],
  educationLevel: {},
  educationLevelError: "",
  formError: "",
};

export default function EducationLevelReducer ( state = initialData, action) {
    switch(action.type){
        case actions.LOADING_EDUCATION_LEVEL:
            return {...state, loading:action.payload}
        case actions.LOADING_EDUCATION_LEVEL_BY_ID:
            return {...state, loadingById: action.payload}
        case actions.SAVE_LOADING_EDUCATION_LEVEL:
            return {...state, saveLoading: action.payload}
        case actions.GET_EDUCATION_LEVEL:
            return {
                ...state,
                educationLevels:action.payload.educationLevels,
                educationLevelsLength:action.payload.educationLevelsLength
            }
        case actions.GET_EDUCATION_LEVEL_BY_ID:
            return{...state, educationLevel: action.payload}
        case actions.FORM_FAIL:
            return {...state, formError: action.payload}
        case actions.EDUCATION_LEVEL_FAIL: 
            return {...state, educationLevelError: action.payload}
        default: 
            return state
    }
}